import React from "react"
import PropTypes from "prop-types"
import Header from '../Header'

import './Layout.scss'

const Layout = ({ lang, socials, children }) => {

  return (
    <>
      <Header 
        lang={lang}
        socials={socials} />
      <main className={`layout`}>
        {children}
      </main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
